module.exports = __webpack_public_path__ + "img/P3LOGOPC.ac34380b.png";